module.exports = __webpack_public_path__ + "img/card28.fa813b52.png";